module.exports = __webpack_public_path__ + "media/images/icons/outlined/file-excel-e80986f425faa149487c9aa3a5b0af39.svg";